import { render, staticRenderFns } from "./MainNavigationBar.vue?vue&type=template&id=7a5fba45&scoped=true&"
import script from "./MainNavigationBar.vue?vue&type=script&lang=ts&"
export * from "./MainNavigationBar.vue?vue&type=script&lang=ts&"
import style0 from "./MainNavigationBar.vue?vue&type=style&index=0&id=7a5fba45&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5fba45",
  null
  
)

export default component.exports